<template>
  <v-container>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">お知らせ管理</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">おしらせ機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12">
        <v-row align="center">
          <v-col>
            <v-btn rounded color="body-2 amber darken-1" :disabled="!isSuperUser" @click="newInformation()" class="mx-2 mb-5">
              <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>新しいお知らせを追加
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-checkbox
              v-model="showActiveOnly"
              label="公開のみ"
              dense
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <div class="px-3">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="12" xl="12" dense>
        総件数：{{filteredItems.length}}件
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['NoticeFrom']"
          :sort-desc="[true]"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectInformation"
          height="450"
          :fixed-header=true
        >
          <template v-slot:item.isActive="{ item }">
            {{ item.isActive === '1' ? '公開' : '非公開' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editInformation"
      persistent
      max-width="60%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          お知らせの編集
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols=2 dense>お知らせ区分</v-col>
            <v-col cols=9 dense>
              <v-select v-model="information.Type" :items="Types" item-value="value" item-text="text"
                append-icon=""
                dense
              >
              </v-select>
            </v-col>
            <v-col cols=2 dense>タイトル</v-col>
            <v-col cols=9 dense><v-text-field v-model="information.Message" counter=64 dense></v-text-field></v-col>
            <v-col cols=2 dense>詳細</v-col>
            <v-col cols=9 dense><v-textarea v-model="information.Detail" counter=1024 dense></v-textarea></v-col>
            <v-col cols=2 dense>開始</v-col>
            <v-col cols=9 dense>
              <v-menu
                v-model="noticeFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="information.NoticeFrom"
                    readonly
                    v-bind="attrs"
                    v-on="on"

                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="information.NoticeFrom"
                  @input="noticeFrom = false"
                  locale="ja"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols=2 dense>終了</v-col>
            <v-col cols=9 dense>
              <v-menu
                v-model="noticeTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="information.NoticeTo"
                    readonly
                    v-bind="attrs"
                    v-on="on"

                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="information.NoticeTo"
                  @input="noticeTo = false"
                  locale="ja"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols=2 dense>ソート順</v-col>
            <v-col cols=9 dense><v-text-field v-model="information.Order" dense type="number" :disabled="!isCreate"></v-text-field></v-col>
            <v-col cols=2 dense>有効</v-col>
            <v-col cols=9 dense>
              <v-select v-model="information.isActive" :items="isActives" item-value="value" item-text="text"
                append-icon=""
                dense
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="isCreate" rounded color="body-2 amber darken-1" :disabled="!isSuperUser" @click="createInformation()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-comment-question-outline</v-icon>お知らせを追加する
          </v-btn>
          <v-btn v-if="!isCreate" rounded color="body-2 amber darken-1" :disabled="!isSuperUser" @click="updateInformation()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-comment-question-outline</v-icon>お知らせを更新する
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn rounded color="body-2 amber darken-1"  @click="cancel()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-close</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { listInformations } from '../graphql/queries'
import { createInformation } from "../graphql/mutations"
import { updateInformation } from "../graphql/mutations"
export default {

  name: "MainteInformation",
  mixins:[],
  head: {
    title: { inner: 'お知らせ一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      loading: false, 

      items: [],
      headers: [
        {
          text: '種別',
          align: 'start',
          value: 'Type',
          class: "grey darken-2 white--text",
          width: "10%" ,
          sortable: false
        },
        {
          text: 'タイトル',
          align: 'start',
          value: 'Message',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: '開始',
          align: 'start',
          value: 'NoticeFrom',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: true 
        },
        {
          text: '終了',
          align: 'start',
          value: 'NoticeTo',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: true 
        },
        {
          text: '表示順',
          align: 'start',
          value: 'Order',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: true 
        },
        {
          text: '公開',
          align: 'start',
          value: 'isActive',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
      ],
      editInformation: false,
      isCreate: false,
      information: {},
      Types: [
        {text:"お知らせ", value:"お知らせ"},
        {text:"重要なお知らせ", value:"重要なお知らせ"},
        {text:"障害発生", value:"障害発生"},
        {text:"障害復旧", value:"障害復旧"},
        {text:"その他", value:"その他"},
      ],

      isActives: [
        {text:"公開", value:"1"},
        {text:"非公開", value:"0"},
      ],
      noticeFrom: false,
      noticeTo: false,
      showActiveOnly: false,
    }
  },
  filters: {
  },
  computed: {
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    isSuperUser : function() {
      return this.$store.state.isSuperUser
    },
    filteredItems() {
      if (this.showActiveOnly) {
        return this.items.filter(item => item.isActive === "1")
      }
      return this.items
    },
  },
  mounted: async function () {
    this.initialize()
  },
  methods: {
    initialize: async function() {
      let items = await API.graphql(graphqlOperation(listInformations, {limit: 999}))
      this.items = items.data.listInformations.items
    },
    selectInformation: function(data) {
      this.isCreate = false
      this.information.id = data.id
      this.information.Type = data.Type
      this.information.Message = data.Message
      this.information.Detail = data.Detail
      this.information.NoticeTo = data.NoticeTo
      this.information.NoticeFrom = data.NoticeFrom
      this.information.Order = data.Order
      this.information.isActive = data.isActive
      this.editInformation = true
    },
    newInformation: function() {
      this.isCreate = true
      this.information = {}
      this.information.Order = 10
      this.information.isActive = "0"
      this.editInformation = true
    },
    updateInformation: async function() {
      await API.graphql(graphqlOperation(updateInformation, {input: this.information}))
      this.editInformation = false
      this.initialize()
    },
    createInformation: async function() {
      delete this.information['id'];
      await API.graphql(graphqlOperation(createInformation, {input: this.information}))
      this.editInformation = false
      this.initialize()
    },
    cancel: function() {
      this.editInformation = false
    }
  }
};
</script>
